import styled, { css } from "styled-components"
export const StyledMain = styled.main`
  grid-row: main-content/footer-start;
  align-self: center;
  justify-self: center;
`
